import { HttpClient } from '../../httpClient'
import { queryString } from '../../httpClient/queryString'
import { OpalApi } from '../../schema'

type ReadViewColumnsV3 = OpalApi<'ReadViewColumnsV3', 200>

export const readViewColumns: ReadViewColumnsV3 = async ({
  params,
}: Parameters<ReadViewColumnsV3>[0] = {}) => {
  const url = new URL('/loupe/v3/view_columns', window.location.origin)

  url.search = queryString(params?.query)

  return HttpClient()
    .get(url.toString())
    .then((res) => res.data)
}
